import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollDirection from './utilities/scroll-direction';

import initMenu from './components/menu';
import initFestivalMenu from './components/festival-menu';
import initSignupForm from './components/signup-form';
import initCookies from './components/cookies';
import initJournalSlider from './components/journal-slider.js';
import initQuotes from './components/quotes';
import initVideoEmbeds from './components/video';
import initScrollTo from './components/scroll-to';
import initAccordions from './components/accordions';
import initInlineVideos from './components/inline-videos';
import initFlickityCarousels from './components/flickity-carousels';
import initSpeakersCarousels from './components/speakers-carousels.js';
import initSponsorsCarousels from './components/sponsors-carousels.js';
import initSpeakers from './components/speakers';
import initSpeakerCards from './components/speaker-cards.js';

initCookies();

// Scroll direction
initScrollDirection();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls && lazyVideoEls.length > 0) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const festivalMenuEl = document.querySelector('.js-festival-menu');

if (festivalMenuEl) {
    initFestivalMenu(festivalMenuEl);
}

const signupFormToggles = document.querySelectorAll('.js-signup-toggle');

if (signupFormToggles && signupFormToggles.length > 0) {
    initSignupForm(signupFormToggles);
}

const scrollSections = document.querySelectorAll('.js-scroll-to');

if (scrollSections && scrollSections.length > 0) {
    initScrollTo(scrollSections);
}

// Journal slider
const journalSliders = document.querySelectorAll('.js-journal-slider');

if (journalSliders && journalSliders.length > 0) {
    initJournalSlider(journalSliders);
}

// Quotes
const quoteEls = document.querySelectorAll('.js-quote');

if (quoteEls && quoteEls.length > 0) {
    initQuotes(quoteEls);
}

const videoEls = document.querySelectorAll('.js-video-embed');

if (videoEls && videoEls.length > 0) {
    initVideoEmbeds(videoEls);
}

const accordions = document.querySelectorAll('.js-accordion');

if (accordions && accordions.length > 0) {
    initAccordions(accordions);
}

const inlineVideos = document.querySelectorAll('.js-inline-video-player');

if (inlineVideos && inlineVideos.length > 0) {
    initInlineVideos(inlineVideos);
}

const flickityCarousels = document.querySelectorAll('.js-flickity-carousel');

if (flickityCarousels && flickityCarousels.length > 0) {
    initFlickityCarousels(flickityCarousels);
}

const speakers = document.querySelector('.js-speakers');

if (speakers) {
    initSpeakers(speakers);
}

const speakerCards = document.querySelectorAll('.js-speaker-card');

if (speakerCards) {
    initSpeakerCards(speakerCards);
}

const speakersCarousels = document.querySelectorAll('.js-speakers-carousel');

if (speakersCarousels && speakersCarousels.length > 0) {
    initSpeakersCarousels(speakersCarousels);
}

const sponsorsCarousels = document.querySelectorAll('.js-sponsors');

if (sponsorsCarousels && sponsorsCarousels.length > 0) {
    initSponsorsCarousels(sponsorsCarousels);
}
